import { getToken, removeTokenCookie } from "./authUtils";

export const handleLogout = ({
	t,
	lang,
	setSnackbarMessage,
	setOpenSnackbar,
	setOpenBackdrop,
	navigate,
	logoutMessage,
}) => {
	const msg = logoutMessage
		? logoutMessage
		: t("equipmentDiagram.loginExpired");
	setSnackbarMessage(msg);
	setOpenSnackbar(true);
	setOpenBackdrop(true);

	const token = getToken();
	const languagePath = lang ? `/${lang}` : "/zh-TW";

	setTimeout(() => {
		setOpenBackdrop(false);

		if (token) removeTokenCookie();
		navigate(`${languagePath}/login-page`);
	}, 3000);
};
